const RESOURCE_NAME = "entities/answerQuestions";

export default {};
